import React from "react";
import { observer } from "mobx-react";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "@mui/icons-material";
import Button from "@mui/material/Button";
import Slider from "@mui/material/Slider";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import TextFieldMask from "../components/textFieldMask";
import { NumericFormat } from "react-number-format";
import InputAdornment from "@mui/material/InputAdornment";
import { IconsSvg, TooltipLine, TooltipIcon } from "TemplateCerere";
import * as Field from "../field";
import "./CrediteSimulare.scss";

const CreditCardSimulareProduse = (props) => {
  const navigateUrl = useNavigate();
  const {
    state,
    comisioane,
    simulare,
    isRequest,
    title,
    subtitle,
    fields,
    jprop,
    actions
  } = props;
  const {
    setSuma,
    updateState,
    creditNew
  } = props;
  const isReadonly =
    fields && (fields.simulare.isReadonly || fields.simulare.docReadOnly);
  const autocalc = jprop.autocalc ?? true;
  const btnNextName =
    jprop.btnNextName ?? "Vreau card de credit";
  const numeCard = fields?.numeCard;
  const modLivrare = fields?.modLivrare;
  const extrasCC = fields?.extrasCC;

  //console.log("CreditCardSimulareProduse", state.credit, numeCard, modLivrare, fields);
  return (
    <>
      <IconsSvg icon="IllustrationHello" />
      <p className="page-title">{title}</p>
      <p className="subtitle-text">{subtitle}</p>
      {state.credit && (
        <>
          <div className="simulare">
            <div className="simulare-doc">
              <div className="doc-table-simulare">

                <div className="label-title">
                  <TooltipLine
                    tooltip="Limita finala acordata a cardului de credit solicitat de dvs. va fi calculata de catre Banca in functie de mai multe variabile utilizate in analiza cererii de credit, de comportamentul dvs. de plata si de istoricul relatiei cu Banca."
                    className="right"
                  >
                    {`De ce suma ai nevoie (${state.credit.valuta}):`}
                  </TooltipLine>
                </div>

                <div className="slider-group">
                  <div className="value-slider">
                    <Slider
                      value={state.suma}
                      step={1000}
                      onChange={(event, value) => {
                        updateState({ suma: value });
                      }}
                      onChangeCommitted={(event, value) => {
                        setSuma(value);
                      }}
                      valueLabelDisplay="auto"
                      //valueLabelDisplay="on"
                      valueLabelFormat={(value) => (
                        <NumericFormat
                          value={value}
                          displayType="text"
                          thousandSeparator="."
                          decimalSeparator=","
                          renderText={(value) => (
                            <div className="percent">{value}</div>
                          )}
                        />
                      )}
                      marks={state.intervalSuma}
                      min={state.credit.suma_minima}
                      max={state.credit.suma_maxima}
                      disabled={isReadonly}
                      className={isReadonly ? "slider-disabled" : null}
                    />
                  </div>

                  <div className="value-suma">
                    <TextFieldMask
                      id="suma"
                      className={`doc-table-value${isReadonly ? " disabled" : ""
                        }`}
                      variant="outlined"
                      value={state.suma}
                      onBlur={(prop) => {
                        var value = prop.target.value
                          ? prop.target.value
                            .replace(/[.]/g, "")
                            .replace(",", ".")
                          : 0;
                        value = parseInt(value);
                        updateState({ suma: value });
                        setSuma(value);
                      }}
                      onKeyDown={(event) => {
                        if (event.key === "." || event.key === ",")
                          event.preventDefault();
                      }}
                      error={!!state.error.suma}
                      helperText={state.error.suma}
                      type="decimal"
                      disabled={isReadonly}
                      isDecimal={true}
                      inputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            {state.credit.valuta}
                          </InputAdornment>
                        ),
                      }}
                      size="small"
                    />
                  </div>
                </div>
              </div>

              <div className="doc-table-simulare">
                <div className="label-title">Perioada (luni)</div>
                <TooltipLine
                  tooltip="Durata Liniei de credit se prelungeste automat, fara semnarea vreunui act aditional, pe perioade consecutive egale cu cea initiala, pana la o perioada de maxim 5 ani/pana la implinirea varstei maxime, in cazul respectarii conditiilor contractuale."
                  className="right"
                >
                  Linia de credit se acorda pe o perioada de {state.perioada} luni cu posibilitatea prelungirii automate pe perioade egale
                </TooltipLine>
                <div className="slider-group">
                </div>
              </div>
              <div className="v-list">
                <div className="group-switch radio-align">
                  <div className="label-title">Tip dobanda</div>

                  <RadioGroup
                    value={state.dobanda_fixa}
                    row
                    onChange={(event) => {
                      updateState(
                        { dobanda_fixa: event.target.value === "true" },
                        true
                      );
                    }}
                    disabled={isReadonly}
                  >
                    <TooltipLine
                      tooltip="Dobanda este calculata dupa urmatoarea formula: indice de referinta IRCC + Marja fixa de dobanda"
                      className="right"
                    >
                      <FormControlLabel
                        value={false}
                        control={<Radio color="primary" />}
                        label="variabila"
                        style={{ marginRight: 0 }}
                        disabled={isReadonly}
                      />
                    </TooltipLine>
                  </RadioGroup>
                </div>
              </div>
              <div className="doc-table-simulare h-list-max">
                <div className="label-title">Limita maxima de retragere numerar</div>
                <div className="value-suma">
                  <NumericFormat
                    value={state.suma * 0.4}
                    displayType="text"
                    thousandSeparator="."
                    decimalSeparator=","
                    suffix={` ${state.credit.valuta}`}
                    decimalScale={2}
                    fixedDecimalScale
                    renderText={(value) => (
                      <div className="percent">{value}</div>
                    )}
                  />
                </div>
              </div>
              <div className="doc-table-simulare h-list-max">
                <div className="label-title">Suma minima de plata</div>
                <div className="value-suma">
                  <NumericFormat
                    value={state.suma * 0.03}
                    displayType="text"
                    thousandSeparator="."
                    decimalSeparator=","
                    suffix={` ${state.credit.valuta}`}
                    decimalScale={2}
                    fixedDecimalScale
                    renderText={(value) => (
                      <div className="percent">{value}</div>
                    )}
                  />
                </div>
              </div>
              <div className="doc-table-simulare h-list-max">
                <div className="label-title">Data emiterii extrasului de card credit</div>
                <TooltipLine tooltip="Prima zi lucratoare a lunii urmatoare celei pentru care s-a incheiat ciclul de tranzactionare." className="right">
                  Prima zi lucratoare a fiecarei luni
                </TooltipLine>
              </div>
              <div className="doc-table-simulare h-list-max">
                <div className="label-title">Data scadentei extrasului de card credit</div>
                <TooltipLine tooltip={"In cazul in care data de " + state.credit.zi_default + " este o zi nelucratoare, atunci data scadentei va fi prima zi lucratoare urmatoare datei de " + state.credit.zi_default + "."} className="right">
                  {state.credit.zi_default} ale fiecarei luni
                </TooltipLine>
              </div>
              {isRequest && (
                <>
                  <div className="doc-table-simulare h-list-max">
                    {numeCard && (<Field.Field4
                      item={numeCard}
                      inline={true}
                      actions={actions}
                      withLabel={true}
                    />)}
                  </div>
                  <div className="doc-table-simulare h-list-max">
                    {modLivrare && (<Field.Field4
                      item={modLivrare}
                      inline={true}
                      actions={actions}
                      withLabel={true}
                    />)
                    }
                  </div>
                  <div className="doc-table-simulare h-list-max">
                    {extrasCC && (<Field.Field4
                      item={extrasCC}
                      actions={actions}
                      inline={true}
                    />)
                    }
                  </div>
                </>)
              }

            </div>

            {autocalc && (
              <div className="simulare-doc">
                {!state.dobanda_fixa && (
                  <div className="doc-table-simulare h-list-max">
                    <div className="label-title">Marja fixa de dobanda</div>
                    <div className="value-suma">
                      <NumericFormat
                        value={simulare.marja}
                        displayType="text"
                        thousandSeparator="."
                        decimalSeparator=","
                        suffix="%"
                        decimalScale={2}
                        fixedDecimalScale
                        renderText={(value) => (
                          <div className="percent">{value}</div>
                        )}
                      />
                    </div>
                  </div>
                )}
                <div className="doc-table-simulare h-list-max">
                  <div className="label-title">Procent dobanda *</div>
                  <div className="value-suma">
                    <NumericFormat
                      value={simulare.procent_dobanda}
                      displayType="text"
                      thousandSeparator="."
                      decimalSeparator=","
                      suffix="%"
                      decimalScale={2}
                      fixedDecimalScale
                      renderText={(value) => (
                        <div className="percent">{value}</div>
                      )}
                    />
                  </div>
                </div>
                <div className="doc-table-simulare h-list-max">
                  <div className="label-title">DAE **</div>
                  <div className="value-suma">
                    <NumericFormat
                      value={simulare.dae}
                      displayType="text"
                      thousandSeparator="."
                      decimalSeparator=","
                      suffix="%"
                      decimalScale={2}
                      fixedDecimalScale
                      renderText={(value) => (
                        <div className="percent">{value}</div>
                      )}
                    />
                  </div>
                </div>

                <div dangerouslySetInnerHTML={{ __html: state.credit.nota }} />

                <div className="label-title">Taxe si comisioane:</div>

                {comisioane &&
                  comisioane.map((comision) =>{ 
                    const [, info] = (comision.nota||"").split("|");
                    return (
                    <div
                      key={comision.denumire_comision}
                      className="doc-table-simulare h-list-max"
                    >
                      <div className="label-title left full">
                        &#8226; {comision.denumire_comision}{info && <TooltipIcon tooltip={info} />}
                      </div>
                      <div className="value-suma">
                        <NumericFormat
                          value={comision.valoare_comision}
                          displayType="text"
                          thousandSeparator="."
                          decimalSeparator=","
                          suffix={
                            comision.comision_procentual
                              ? "%"
                              : ` ${state.credit.valuta}`
                          }
                          decimalScale={2}
                          fixedDecimalScale
                          renderText={(value) => (
                            <div className="interest">{value}</div>
                          )}
                        />
                      </div>
                    </div>
                  )})}



                <div>
                  ** DAE este Dobanda Anuala Efectiva si include taxele si
                  comisioanele aferente creditului, percepute de banca.
                </div>
                {comisioane &&
                  comisioane
                    .filter((x) => x.nota)
                    .map((comision) => {
                      const [nota] = (comision.nota||"").split("|");
                      return (
                        <div key={comision.denumire_comision}>
                          {nota} 
                        </div>
                      )
                    }
                    )}
              </div>
            )}
            {isRequest && (
              <>
                <div className="footer">
                  {jprop.footer}
                </div>
              </>
            )}
          </div>

          {
            <div className="login-btn-group">
              <Button
                variant="contained"
                color="primary"
                className="login-btn"
                onClick={() => creditNew(navigateUrl)}
                endIcon={<ArrowRight fontSize="large" />}
              >
                {btnNextName}
              </Button>
            </div>
          }
        </>
      )
      }
    </>
  );
};

export default observer(CreditCardSimulareProduse);
